<template>
    <i :class="getClass" :style="{fontSize:size,color}" @click="click"/>
</template>
<script>
export default {
  props: {
    name: { type: String, required: true },
    size: { type: String, required: false },
    color: { type: String, required: false }
  },
    computed:{
        getClass:function () {
          return `iconfont wechat-${this.name}`
      }
    },methods:{
      click(){
          this.$emit("click")
      }
    }
};
</script>
<style lang="less" scoped>
 @import "//at.alicdn.com/t/font_1382691_k2a2dcdx8h8.css";
</style>
